import { render, staticRenderFns } from "./error.vue?vue&type=template&id=bee2c2e6&scoped=true&"
import script from "./error.vue?vue&type=script&lang=js&"
export * from "./error.vue?vue&type=script&lang=js&"
import style0 from "./error.vue?vue&type=style&index=0&id=bee2c2e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee2c2e6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Article: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Article/index.vue').default,EssentialButtons: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/EssentialButtons/index.vue').default,Section: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Section/Index.vue').default})
